module.exports = __webpack_public_path__ + "img/1.7d0c6a37.png";